import React, { FunctionComponent } from "react";

import { FrameAttributeSharedProps } from "../../types";
import { defaultIconCanRenderEmpty } from "../../utils";
import { LiteListFrameGeneralAttribute } from "../LiteListFrameGeneralAttribute";
import { LiteListFrameIconAttribute } from "./attribute";
import { LiteListFrameEmptyIconAttributePlaceholder } from "./placeholders/LiteListFrameEmptyIconAttributePlaceholder";
import { LiteListFrameSkeletonIconAttributePlaceholder } from "./placeholders/LiteListFrameSkeletonIconAttributePlaceholder";

export type LiteListFrameIconAttributeComponentProps = FrameAttributeSharedProps;

export const LiteListFrameIconAttributeComponent: FunctionComponent<LiteListFrameIconAttributeComponentProps> = (
    props,
) => (
    <LiteListFrameGeneralAttribute
        {...props}
        EmptyPlaceholder={LiteListFrameEmptyIconAttributePlaceholder}
        SkeletonPlaceholder={LiteListFrameSkeletonIconAttributePlaceholder}
        AttributeComponent={LiteListFrameIconAttribute}
        canRenderEmpty = {defaultIconCanRenderEmpty}
    />
);
